<template>
	<div class="content background1">
		<div class="tableBox11">
			<div class="tableMes">
				<div class="table" style="padding: 0">
					<div class="treeMes" v-if="getTreeMes=='1'">
						<p class="title">{{$t('label_308')}}</p>
						<div class="chooseBox spaceBetween">
							<div class="selectBox">
								<div>
									<div class="selectChoose">
										<div class="selectText" style="width: 70px;">
											<p>{{$t('label_297')}}</p>
										</div>
										<div class="select" style="width: 300px">
											<el-input v-model="searchDataList.name" clearable></el-input>
										</div>
									</div>
								</div>
								<div>
									<div class="selectChoose">
										<div class="selectText" style="width: 160px;">
											<p>{{$t('label_300')}}</p>
										</div>
										<div class="select" style="width: 300px">
											<el-input v-model="searchDataList.code" clearable></el-input>
										</div>
									</div>
								</div>
							</div>
							<div class="buttonBox">
								<div>
									<div class="chooseButton sendButton" @click="search"><i class="el-icon-search"></i>{{$t('btn_2')}}</div>
								</div>
							</div>
						</div>
						<div class="spotMes2Box" style="height: calc(100% - 218px);">
							<div class="tableMin" style="height: calc(100% - 100px);">
								<!--button按钮-->
								<div class="buttonBox" style="margin-bottom: 10px;">
									<div>
										<div class="chooseButton searchButton" @click="addFactory($t('btn_14'))" v-if="MenuRoleList.indexOf('139')>=0">
											<i class="el-icon-circle-plus-outline"></i>{{$t('btn_14')}}
										</div>
										<div class="chooseButton searchButton" @click="addFactory($t('btn_15'))" v-if="MenuRoleList.indexOf('140')>=0">
											<i class="el-icon-edit-outline"></i>{{$t('btn_15')}}
										</div>
										<div class="chooseButton deleteButton" @click="delWarehouse" v-if="MenuRoleList.indexOf('141')>=0"><i class="el-icon-delete"></i>{{$t('btn_16')}}</div>
									</div>
								</div>
								<!--table start-->
								<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDataTreeTime" highlight-current-row @current-change="handleCurrentChangeTree"
								 border style="width: 100%;" height="100%" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
									<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex" width="50">
									</el-table-column>
									<el-table-column :label="$t('label_297')" align="left" prop="name">
									</el-table-column>
									<el-table-column :label="$t('label_300')" align="left" prop="code">
									</el-table-column>
									<el-table-column prop="remark" :label="$t('btn_29')" align="left">
										<template slot-scope="scope">
											<popMesBox :popMes="scope.row.remark" :hoverMes="scope.row.remark" :popWidth="200"></popMesBox>
										</template>
									</el-table-column>
									<el-table-column :label="$t('label_304')" align="center">
										<template slot-scope="scope">
											<span class="look_font" @click="addFactory($t('btn_38'),scope.row)">{{$t('btn_38')}}</span>
										</template>
									</el-table-column>
								</el-table>
								<div style="position: absolute;bottom: 30px;left: 30%">
									<Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
									 @parentMethod="searchPage"></Page>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--		<exportMes :exportTitle="exportTitle" :exportData="tableDataTreeTimeExport" :exportList="exportList" style="width: 100%;height: 100%"-->
		<!--		 ref="exportBox"></exportMes>-->
		<!--弹窗start-->
		<el-dialog v-loading="saveLoading" :title="deviceParamTitle" :visible.sync="dialogDeviceSpot" append-to-body :close-on-click-modal='false'
		 width="800px" top="5%" :before-close="handleClose" custom-class="dialogBox">
			<div class="dialogBoxMes" style="padding:0 50px 0 10px;">
				<!--输入框-->
				<el-row class="dialogMes">
					<el-col :span="1"></el-col>
					<el-col :span="3"><span style="color: #ff0000">*</span>{{$t('label_297')}}</el-col>
					<el-col :span="8">
						<el-input v-model="formModel.name" :disabled="this.typestate?true:false" clearable></el-input>
					</el-col>
					<el-col :span="1"></el-col>
					<el-col :span="4"><span style="color: #ff0000">*</span>{{$t('label_300')}}</el-col>
					<el-col :span="7">
						<el-input v-model="formModel.code" :disabled="this.typestate?true:false" clearable>
						</el-input>
					</el-col>
				</el-row>
				<!--树-->
				<el-row class="dialogMes">
					<el-col :span="1"></el-col>
					<el-col :span="3"><span style="color: #ff0000">*</span>{{$t('label_304')}}</el-col>
					<el-col :span="20">
						<div class="treeNoChoose">
							<div class="selectSpot2" style='height: 100%;'>
								<el-tree :load="loadTree" @check-change="treeCheck" ref="tree" show-checkbox check-strictly lazy :props="treeProps"
								 :accordion='true' node-key="id" :default-expanded-keys="expandedKeys" v-if="treeType" >
									<div class="custom-tree-node" slot-scope="{node,data}">
										<div class="title" style="width:250px;position:relative;display: flex">
											<p style="width: 150px;display: block;overflow: hidden;line-height: 30px;text-overflow: ellipsis;-o-text-overflow: ellipsis; white-space: nowrap;">
												{{data.name}}
											</p>
										</div>
									</div>
								</el-tree>
							</div>
						</div>
					</el-col>
				</el-row>
				<!--备注-->
				<el-row class="dialogMes">
					<el-col :span="1"></el-col>
					<el-col :span="3">{{$t('btn_29')}}</el-col>
					<el-col :span="20">
						<el-input type="textarea" :placeholder="$t('input_46')" maxlength="100" show-word-limit v-model="formModel.remark"
						 :disabled="this.typestate?true:false">
						</el-input>
					</el-col>
				</el-row>
			</div>
			<!--按钮-->
			<span slot="footer" class="dialog-footer">
				<span class="buttonBox" style="justify-content: center">
					<div class="chooseButton sendButton" @click="savelist" v-if="!this.typestate">{{$t('btn_13')}}</div>
					<div class="chooseButton searchButton" style="width: 150px" @click="handleClose">{{$t('btn_1')}}</div>
				</span>
			</span>
		</el-dialog>
		<!--弹窗end-->
	</div>
</template>

<script>
	import "@/assets/css/map/map.css"
	import "@/assets/css/common/spot.css"
	import Page from "@/components/common/page";
	import utils from '@/utils/utils'
	import calendar from "@/components/list/calendar/calendar";
	import file from "@/assets/js/file/file.js";
	import exportMes from "@/components/list/export/export";
	import popMesBox from "@/components/list/popover/pop";
	import organizationTabJs from "@/assets/js/system/organizationTab.js";
	import menuTabJs from "@/assets/js/system/menuTab.js";
	import electronDocument from "../../components/list/displayPage/electronDocument";
	export default {
		name: 'inventoryTask',
		components: {
			Page,
			calendar,
			exportMes,
			popMesBox,
		},
		data() {
			return {
        saveLoading: false,
				kwName: '', // 名称
				kwCode: '', // 编号
				formModel: {
					name: '',
					code: '',
					organizationIds: [],
					remark: '',
				},
				expandedKeys: [],
				treeProps: {
					label: 'name',
				},
				dateTime: '', //  非实时当前时间
				tableDatadialog: [], // list 数组
				dialogDeviceSpot: false, // 默认弹窗状
				pageNum: 1,
				select: 0,
				pageSize: 10,
				pageCount: 0,
				Readytime: '',
				height: 620,
				MenuRoleList: [],
				tableDataTreeInfo: {},
				factoryDialogTitle: this.$t('btn_14'),
				getTreeMes: '1',
				dialogFactory: false,
				searchDataList: {
					name: '', // 名称
					code: '', // 编号
				},
				tableDataTreeTimeExport: [],
				tableDataTree: [],
				factoryTypeList: [],
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				delelist: [], // 弹框list
				checkList: '', // 下拉选数据
				deviceParamTitle: this.$t('btn_14'), // 弹窗title
				tableDataTreeTime: [], // 页面list
				Warehouseid: '',
				ckid: '',
				equipmentPartsInventoryRecords: [], // 添加数据的数组
				jobObj: '',
				allMenus: [],
				nodeId: '',
				selecttype: false, // 树选择的数据
				selectid: [], //  选中的节点id
				typestate: false, // 点击查看控制输入框禁用
				treeType: true,
				checkTree:false,
			}
		},
		methods: {
			// 新增  编辑  查看按钮   val按钮状态  row 行数据
			addFactory(val, row) {
				this.checkTree=false;
				this.deviceParamTitle = val // title 名称
				if (row && row != '' && row != undefined) var row = row.id // 判断是否是查看按钮  获取行id
				if (val == this.$t('btn_15')) {
					if (this.tableDataTreeInfo == '' || this.tableDataTreeInfo == null || this.tableDataTreeInfo == undefined) { // 判断一下 是否点击查看的数据
						this.$message({
							message: this.$t('msg_1'),
							type: 'warning'
						});
						return false
					} else {
						this.formModel = this.tableDataTreeInfo //  数据和id赋值
						var checkid = this.tableDataTreeInfo.id
					}
					if (checkid == '' || checkid == null || checkid == undefined) {
						this.$message({
							message: this.$t('msg_1'),
							type: 'warning'
						});
						return false
					} else {
						this.$nextTick(_ => {
							this.expandedKeys = []; // 组织id
							this.$refs.tree.setCurrentKey(this.nodeId); //  取消选中状态
							this.$refs.tree.setCheckedKeys([this.nodeId]);
						});
						this.treeType = false;
						this.$nextTick(function() {
							this.treeType = true
						})
						this.dialogDeviceSpot = true;
						this.typestate = false // 按钮状态
						file.equipmentPartsDetail(checkid).then((response) => {
							const data = response.data;
							if (data.code == "1") {
								this.formModel = data.data // 赋值
								this.$nextTick(_ => {
									this.expandedKeys = this.formModel.defaultExpandedKeys;
									this.$refs.tree.setCurrentKey(this.formModel.organizationIds[0]);
									this.$refs.tree.setCheckedKeys(this.formModel.organizationIds);
								});
							}
						}).catch((response) => {
							console.log(response)
						})
					}
				} else if (val == this.$t('btn_14')) { // 新增按钮
					this.deviceParamTitle = val
					this.formModel.organizationIds = []
					this.formModel = {
							name: '',
							code: '',
							organizationIds: [],
							remark: '',
						},
						this.$nextTick(_ => {
							this.expandedKeys = []; // 组织id
							this.$refs.tree.setCurrentKey(this.nodeId); //  取消选中状态
							this.$refs.tree.setCheckedKeys([this.nodeId]);
						});
					this.treeType = false;
					this.$nextTick(function() {
						this.treeType = true
					})
					this.dialogDeviceSpot = true;
					this.typestate = false
				} else { // 查看按钮
					this.checkTree=true;
					this.$nextTick(_ => {
						this.expandedKeys = []; // 组织id
						this.$refs.tree.setCurrentKey(this.nodeId); //  取消选中状态
						this.$refs.tree.setCheckedKeys([this.nodeId]);
					});
					this.treeType = false;
					this.$nextTick(function() {
						this.treeType = true
					})
					this.dialogDeviceSpot = true;
					this.typestate = true
					file.equipmentPartsDetail(row).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.formModel = data.data
							this.$nextTick(_ => {
								this.expandedKeys = this.formModel.defaultExpandedKeys; // 组织id
								this.$refs.tree.setCurrentKey(this.formModel.organizationIds[0]);
								this.$refs.tree.setCheckedKeys(this.formModel.organizationIds);
							});
						}
					}).catch((response) => {
						utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
					})
				}
			},
			// 点击保存
			savelist() {
        this.saveLoading = true;
        console.log(this.formModel.organizationIds)
				if (this.deviceParamTitle == this.$t('btn_14')) {
					if (!this.formModel.name || this.formModel.name == '' || this.formModel.name == undefined) { // 判断名称
						utils.messageAlert(this.$t('msg_112'), this.$t('label_358'), this.$t('label_100'));
            this.saveLoading = false;
						return false
					}
					if (!this.formModel.code || this.formModel.code == '' || this.formModel.code == undefined) { // 判断编号
						utils.messageAlert(this.$t('msg_133'), this.$t('label_358'), this.$t('label_100'));
            this.saveLoading = false;
						return false
					}
					if (this.formModel.organizationIds.length>0) { // 判断选中状态
						file.warehouse(this.formModel).then((response) => {
							const data = response.data;
							if (data.code == "1") {
								this.$message({
									message: this.$t('msg_18'),
									type: 'success'
								});
								this.search()
								this.dialogDeviceSpot = false;
							} else {
								utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
							}
              this.saveLoading = false;
						}).catch((response) => {
							utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
              this.saveLoading = false;
						})
					} else {
						utils.messageAlert(this.$t('msg_115'), this.$t('label_358'), this.$t('label_100'));
            this.saveLoading = false;
					}
				} else { // 编辑状态
					if (!this.formModel.name || this.formModel.name == '' || this.formModel.name == undefined) {
						utils.messageAlert(this.$t('msg_112'), this.$t('label_358'), this.$t('label_100'));
            this.saveLoading = false;
						return false
					}
					if (!this.formModel.code || this.formModel.code == '' || this.formModel.code == undefined) {
						utils.messageAlert(this.$t('msg_133'), this.$t('label_358'), this.$t('label_100'));
            this.saveLoading = false;
						return false
					}
					if (this.formModel.organizationIds.length>0) {
						file.equipmentPartsPut(this.formModel).then((response) => {
							const data = response.data;
							if (data.code == "1") {
								this.$message({
									message: this.$t('msg_19'),
									type: 'success'
								});
								this.search()
								this.dialogDeviceSpot = false;
							} else {
								utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
							}
              this.saveLoading = false;
						}).catch((response) => {
							utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
              this.saveLoading = false;
						})
					} else {
            this.saveLoading = false;
						utils.messageAlert(this.$t('msg_115'), this.$t('label_358'), this.$t('label_100'));
					}
				}
			},
			//  删除按钮
			delWarehouse() {
				if (this.tableDataTreeInfo == '' || this.tableDataTreeInfo == null || this.tableDataTreeInfo == undefined) { // 判断一下 是否点击查看的数据
					this.$message({
						message: this.$t('msg_1'),
						type: 'warning'
					});
					return false
				} else {
					var checkid = this.tableDataTreeInfo.id
				}
				if (checkid == '' || checkid == null || checkid == undefined) {
					this.$message({
						message: this.$t('msg_1'),
						type: 'warning'
					});
					return false
				} else {
					var param = this.tableDataTreeInfo.id;
					this.$confirm(this.$t('msg_88'), this.$t('label_358'), {
						confirmButtonText: this.$t('label_100'),
						cancelButtonText: this.$t('btn_1'),
						type: 'warning',
						center: true
					}).then(() => {
						file.delWarehouse(param).then((response) => {
							const data = response.data;
							if (data.code == "1") {
								this.$message({
									message: this.$t('msg_14'),
									type: 'success'
								});
								this.search()
							}
						}).catch((response) => {
							utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
						})
					}).catch(() => {
						this.$message({
							type: 'info',
							message: this.$t('label_478')
						});
					});
				}
			},

			//组织机构
			loadTree(node, resolve) {
				if (node.level === 0) {
					let child = this.getChildren(0);
					child.then((res) => {
						if(this.checkTree){
							for(var i=0;i<res.length;i++){
								res[i].disabled=true
							}
						}
						resolve(res);
					});
				} else {
					let child = this.getChildren(node.data.id);
					child.then((res) => {
						if (res == "") {
							return resolve([]);
						} else {
							if(this.checkTree){
								for(var i=0;i<res.length;i++){
									res[i].disabled=true
								}
							}
							resolve(res);
						}
					});
				}
			},
			async getChildren(pid) {
				let childArr = [];
				await organizationTabJs.getChildren({
					pid: pid,
					state: 1
				}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						childArr = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
				return childArr;
			},
			organizationClick(data) {
				this.nodeId = data.id;
				this.expandedKeys = [this.nodeId];
				this.hierarchy = data.hierarchy;
				this.level = data.level;
				this.organizationName = data.name;
				this.searchPage({
					pageNum: this.pageNum,
					pageSize: this.pageSize,
				});
				this.rolesArray = [];
				this.treeCheck(data, true, '');
			},
			treeCheck(data, checked, indeterminate) {
				this.selecttype = checked // 判断节点是否选中
				if (checked) {
					this.formModel.organizationIds.push(data.id)
				} else {
					let index = this.formModel.organizationIds.indexOf(data.id);
					this.formModel.organizationIds.splice(index, 1);
				}
			},
			// 点击查询
			selectlist(param) {
				file.equipmentParts(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableDataTreeTime = data.data.records // table数据
						this.pageCount = data.data.total;
						this.pageSize = data.data.size;
						this.pageNum = data.data.current;
						this.$refs['pageModel'].setCurrent(this.pageNum);
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			searchPage(param) {
				var dataParam = this.searchDataList; // 搜索条件
				var newParam = Object.assign(param, dataParam);
				this.pageNum = newParam.pageNum;
				this.pageSize = newParam.pageSize;
				this.selectlist(newParam);
			},
			deviceCheckItemInfoEdit(title) {
				this.dialogDeviceSpot = true;
			},
			// 点击提交按钮
			getIndex(index) {
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			exportClick() {
				this.$refs.exportBox.setExportExcel();
			},
			selectProp: function(index) {
				console.log(index)
				this.select = index
			},
			// 关闭弹窗
			handleClose() {
				this.dialogDeviceSpot = false;
			},
			handleCurrentChangeTree(info) {
				this.tableDataTreeInfo = info;
			},
			handleCurrentChangeTreeTime(info) {},
			search() {
				let param = {
					pageNum: 1,
					pageSize: this.pageSize
				}
				this.searchPage(param);
			},
		},
		created() {
			this.MenuRoleList = this.$store.getters.getMenu;
			this.search()
		},
	}
</script>

<style scoped>
	.el-col {
		line-height: 40px;
	}

	.look_font {
		color: #0353C1;
		font-size: 14px;
		;
	}

	.look_font:hover {
		color: #0353C1;
		font-size: 14px;
		cursor: pointer;
		text-decoration: underline;
	}

	.buttonBox .chooseButton {
		margin-left: 0px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/part/locationManagement.vue